import { Spinner } from 'flowbite-react'
import React from 'react'

const Loading = () => (
  <div
    className="fixed top-0 left-0 w-full h-full bg-gray-200 z-50 flex items-center justify-center bg-opacity-20">
    <Spinner size="xl" />
  </div>
)

export default Loading
